// extracted by mini-css-extract-plugin
module.exports = {"section":"FooterUSP_section__GfWXv","container":"FooterUSP_container__XVKWU"};